import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";
import { enum as zEnum } from "zod/v4";
import { ShopifyAppNames } from "../../sales-channels";

export enum CloudXUPCType {
  SKU = "sku",
  BARCODE = "barcode",
}

export enum CloudXCancelASNOn {
  REJECT = "reject",
  RESET = "reset",
  BOTH = "both",
  NEVER = "never",
}

const CloudXIntegrationDataSchema_ = z.object({
  clientSecret: z.string().optional(),
  warehouseAsPlainString: z.string(),
  warehouseTimezone: z.string().optional(),
  testMode: z.boolean(),
  autoProcessReturns: z.boolean(),
  upcType: zEnum(CloudXUPCType),
  excludedAppNames: z.array(createEnum(ShopifyAppNames)),
  cancelASNOn: zEnum(CloudXCancelASNOn).optional(),
});

export const CloudXIntegrationDataSchema: z.ZodType<CloudXIntegrationData> =
  CloudXIntegrationDataSchema_;
export interface CloudXIntegrationData
  extends z.infer<typeof CloudXIntegrationDataSchema_> {}
